<template>
  <div>
    <div class="mb-2">
      {{ $t("freespins.form.doCSVUpload") }}
      <v-tooltip
        top
        content-class="tooltip"
      >
        <template v-slot:activator="{ on, attrs}">
          <v-icon
            color="info"
            v-bind="attrs"
            v-on="on"
            small
          >
            mdi-information-outline
          </v-icon>
        </template>
        <span v-if="parent == 'userById'">
          {{ $t("freespins.form.CSVUploadTip") }}
        </span>

        <span v-if="parent == 'massImportUsers'"
          v-html="$t('massImportAffiliatesRequiredColumns')"
        ></span>
      </v-tooltip>
    </div>
    <div
      class="d-flex"
      :class="isXsmall ? 'flex-column' : ' align-top'"
      style="gap: 16px"
    >
      <v-file-input
        class="d-flex flex-grow"
        truncate-length="15"
        accept=".csv"
        :label="$t('freespins.form.inputCsvLabel')"
        dense
        outlined
        :error="csv.fileError"
        :rules="[rules.required]"
        hide-details="auto"
        show-size
        clearable
        @click:clear="clearCsvInput()"
        @change="handleCSVUpload($event)"
      ></v-file-input>

      <v-btn
        @click="csv.seeCsvUsers = true"
        :outlined="parent == 'massImportUsers'"
        :class="parent == 'massImportUsers' ? '' : 'info'"
        :disabled="!csv.parsed || csv.fileError"
        >
      {{ $t("freespins.form.see") }}
      </v-btn>
  
      <v-btn
        class="info"
        :disabled="!csv.parsed || csv.sending || csv.fileError"
        :loading="csv.sending"
        @click="importAffiliates()"
      >
        {{ $t("toSend") }}
      </v-btn>

      <!-- Dialog See Csv Users -->
      <v-dialog
        v-model="csv.seeCsvUsers"
        max-width="600"
        scrollable
      >
        <v-card>
          <v-toolbar
            dense
          >
            <v-toolbar-title class="d-flex align-center">
              {{ $t("users") }}
              <span class="caption ml-2">({{ csv.content.length }})</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="csv.seeCsvUsers = false" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="my-4" style="height: 400px">
            <div v-if="parent == 'userById'"
              class="py-8 mx-auto"
              style="width: 90%"
            >
              <v-row no-gutters style="row-gap: 8px;">
                <v-col
                  v-for="(user, index) in csv.content"
                  :key="index"
                  cols="12"
                  md="6"
                  lg="6"
                  sm="6"
                  xl="6"
                >
                  <div v-if="user.id">
                    ID: {{ user.id }}
                    <div v-if="user.Nome" class="grey--text">
                      {{ user.Nome }}
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div v-if="parent == 'massImportUsers'">
              <div v-for="(line, index) in csv.content" :key="line.name">
                <span v-if="line.local_manager_id"
                  class="my-4 subtitle-1 white--text"
                >
                  Gerente Local ID: {{ line.local_manager_id }}
                </span>

                <div class="caption">
                  <span>Afiliado:</span>
                  <ul>
                    <li>
                      {{ line.login }}
                    </li>
                    <li>
                      {{ line.name }}
                    </li>
                    <li>
                      {{ line.password }}
                    </li>
                  </ul>
                </div>

                <v-divider
                  v-if="index + 1 < csv.content.length"
                  :key="index"
                  class="my-3"
                />
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="csv.importResponse"
        class="d-flex"
        max-width="600"
        scrollable
      >
        
        <v-card>
          <v-toolbar
          dense
        >
          <v-toolbar-title
            class="d-flex align-center"
          >
            {{ $t("operationLog") }}
            <!-- <span class="caption ml-2">
              ({{ csv.content.length }})
            </span> -->
          </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              @click="csv.importResponse = false"
              icon
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text style="height: 400px">
            <div class="my-4 title white--text">
              {{ csv.mainMessage }}
            </div>
            <div v-if="csv.importHasErrors">
              <div class="mb-4">{{ $t("someErrorsWereFound") }}:</div>
              <div
                v-for="(log, index) in csv.errorLogs" :key="index"
                class="caption grey--text text--lighten-1"
              >
                <span>Login: {{ log.login }}</span> -
                <span class="white--text">{{ log.message }}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
// import rules from "../generateFields/rules";
import { validate } from "@/util/validate.js";
export default {
  name: "input-import-csv-file",

  props: {
    parent: {
      type: String,
      required: true
    },
  },

  data: () => ({
    // CSV
    csv: {
      file: "",
      content: [],
      parsed: false,
      usersByCsv: [],
      usersMassImport: [],
      seeCsvUsers: false,
      fileError: false,
      sending: false,
      importHasErrors: false,
      errorLogs: [],
      mainMessage: "",
      importResponse: false
    },

    rules: {
      required: validate.required,
    },
  }),

  computed: {
    isXsmall() {
      return this.$vuetify.breakpoint.name == 'xs';
    }
  },

  methods: {
    handleUsersByID(results) {
      this.csv.content = results.data.flatMap((user) => {
        const id = user.id || user.Id || user.iD || user["ID"];
        if (id) {
          return { ...user, id };
        } else {
          return [];
        }
      });

      this.csv.usersByCsv = results.data.flatMap((user) => {
        const id = user.id || user.Id || user.iD || user["ID"];
        return id ? id : []
      });

      if (this.csv.usersByCsv.length == 0) {
        this.csv.content = [];
        this.csv.parsed = false;
        this.csv.fileError = true;
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("freespins.form.idColumnEmpty"),
          color: "warning",
        })

        return
      }
    },

    handleMassImportUsers(results) {
      if (results.data.length == 0) {
        this.csv.content = [];
        this.csv.parsed = false;
        this.csv.fileError = true;
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("massImportAffiliatesMIN"),
          color: "warning",
        })

        return
      }

      if (results.data.length > 1001) {
        // verifica 1001 linhas pois a primeira linha
        // são as colunas
        this.csv.content = [];
        this.csv.parsed = false;
        this.csv.fileError = true;
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("massImportAffiliatesMAX"),
          color: "warning",
        })

        return
      }

      this.csv.content = results.data;
      this.csv.usersMassImport = results.data;
    },

    parseFile() {
      this.csv.fileError = false;
      this.$papa.parse(this.csv.file, {
        header: true,
        encoding: 'utf-8',
        skipEmptyLines: true,
        complete: function(results) {
          this.csv.fileError = false;

          if (this.parent == "userById") this.handleUsersByID(results);
          if (this.parent == "massImportUsers") this.handleMassImportUsers(results);
 
          this.csv.parsed = true;
        }.bind(this),
        error: function(error, file) {
          console.log(error, file);
        }.bind(this)
      });
    },

    handleCSVUpload(event) {
      if (!event) return this.clearCsvInput();
      this.csv.file = event;
      if (this.csv.file.type !== "text/csv") {
        this.csv.file = "";
        this.csv.content = [];
        this.csv.parsed = false;
        this.csv.fileError = true;
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("freespins.form.fileNotAllowed"),
          color: "warning"
        })
        return
      }
      this.parseFile();
    },

    importAffiliates() {
      this.csv.sending = true;
      const body = this.csv.usersMassImport;

      this.$axios
        .post(`${this.$prefix()}/affiliates/addBatchAffiliates`, body)
        .then((resp) => {
          this.csv.sending = false;
          this.csv.importResponse = true;

          if (resp.data.errors) {
            this.csv.mainMessage = resp.data.message;
            this.csv.importHasErrors = true;
            this.csv.errorLogs = resp.data.errors;
          }
        })
        .catch(() => {
          this.csv.sending = false;
          this.csv.importResponse = false;
        })
    },

    clearCsvInput(){
      this.csv.file = "";
      this.csv.seeCsvUsers = false;
      this.csv.parsed = false;
      this.csv.fileError = false;
      this.csv.content = [];
      this.csv.usersByCsv = [];
    },
  }
}
</script>

<style>
.tooltip {
  max-width: 360px;
}

</style>